import { render, staticRenderFns } from "./message-bubble.vue?vue&type=template&id=238ec0d5&scoped=true&"
import script from "./message-bubble.vue?vue&type=script&lang=js&"
export * from "./message-bubble.vue?vue&type=script&lang=js&"
import style0 from "./message-bubble.vue?vue&type=style&index=0&id=238ec0d5&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "238ec0d5",
  null
  
)

export default component.exports